import React, {
    useCallback, useState, useEffect, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { renderContentFromMetadata, validateContentFromMetadata } from '@jutro/uiconfig';
import { useDependencies } from 'gw-portals-dependency-react';
import { useValidation } from 'gw-portals-validation-react';
import { useAuthentication } from 'gw-digital-auth-react';
import metadata from './ApprovedRepairer.metadata.json5';
import styles from './ApprovedRepairer.module.scss';
import isUnitedKingdomChosen from '../../../gw-capability-fnol-ca-react/pages/Vehicles/VehiclesPage';
import ClaimDetailsComponent from '../../../gw-capability-claim-react/pages/ClaimDetails/ClaimDetails';
import { TranslatorContext } from '@jutro/locale';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { ModalNextProvider } from '@jutro/components';
import { Address } from 'gw-capability-fnol-common-react';

function ApprovedRepairer(props) {
    const { authHeader } = useAuthentication();
    const { ClaimService } = useDependencies('ClaimService');
    const [arLocation, updateLocation] = useState({
        vehicleAddressLine1: '',
        vehicleAddressLine2: '',
        vehicleAddressLine3: '',
        vehicleCity: '',
        vehicleCounty: '',
        postCode: '',
        country: '',
    });

    const { match, history, id, onValidate, path: claimVM } = props;
    const { isComponentValid, registerComponentValidation } = useValidation('ApprovedRepairer');
    const { AddressLookupService } = useDependencies('AddressLookupService');
    const viewModelService = useContext(ViewModelServiceContext);
    const addressViewModel = viewModelService.create(
        _.get(claimVM, 'approvedRepairer') || new Address(),
        'cc',
        'edgev1141.capabilities.address.dto.AddressDTO'
    );

    const translator = useContext(TranslatorContext);
    const [addressVM] = useState(addressViewModel);
    const [addressChange, setAddressChange] = useState({
        predefinedAddress: true,
        exactAddress: false,
        locDescOnly: false,
        map: false
    });
    const [lookupResult_Ext, updatelookupResult_Ext] = useState(null);
    const [showLookupResult_Ext, updateShowLookupResult_Ext] = useState(false);
    const [showPostCodeLoader, updateshowPostCodeLoader] = useState(false);

    const writeValue = useCallback(
        (value, path) => {
            const savedLocation = _.clone(arLocation);
            _.set(savedLocation, path, value);
            updateLocation(savedLocation);
        },
        [arLocation]
    );

    const redirectToPreviousState = useCallback(() => {
        const {
            location: {
                state: { redirectPath }
            }
        } = history;
        const nextPath = `/claims/${match.params.claimNumber}`;
        history.push({
            pathname: nextPath,
            state: {
                redirectPath,
                selectedTab: 'repairTab'
            }
        });
    }, [history, match]);

    const handleSave = useCallback(() => {
        return ClaimService.createApprovedRepairer(match.params.claimNumber, arLocation, authHeader).then(() => {
            redirectToPreviousState();
        });
    }, [ClaimService, authHeader, match, arLocation, redirectToPreviousState]);

    const onBackClicked = useCallback(
        (e) => {
            e.preventDefault();
            redirectToPreviousState();
        },
        [redirectToPreviousState]
    );

    const readValue = useCallback(
        (id, path) => {
            return _.get(arLocation, path);
        },
        [arLocation]
    );

    const overrides = useMemo(
        () => ({
            '@field': {
                onValueChange: writeValue
            },
            saveBtnId: {
                disabled: !isComponentValid
            },
            caVehiclepostCodeLookupButton: {
                //visible: isUnitedKingdomChosen
            },
            country: {
                value :addressVM.address
            }
        }),
        [isComponentValid, writeValue]
    );

    const resolvers = useMemo(
        () => ({
            resolveValue: readValue,
            resolveCallbackMap: {
                handleSave: handleSave,
                handleCancel: redirectToPreviousState,
                onBackClicked: onBackClicked
            },
            resolveClassNameMap: styles
        }),
        [handleSave, onBackClicked, readValue, redirectToPreviousState]
    );

    const validateForm = useCallback(() => {
        return validateContentFromMetadata(metadata.pageContent, overrides, resolvers);
    }, [overrides, resolvers]);

    useEffect(() => {
        registerComponentValidation(validateForm);
    }, [registerComponentValidation, validateForm]);

    // Defensive check for addressVM
    if (!addressVM || !addressVM.value) {
        return <div>Loading...</div>;
    }

    return (
        <div className={styles.approvedRepairer}>
            {renderContentFromMetadata(metadata.pageContent, overrides, resolvers)}
        </div>
    );
}

ApprovedRepairer.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({
            summarystate: PropTypes.shape({}).isRequired
        }).isRequired
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            claimNumber: PropTypes.string
        })
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func,
        location: PropTypes.shape({
            state: PropTypes.shape({
                redirectPath: PropTypes.string
            })
        })
    }).isRequired
};

export const ApproveRepairerComponent = ApprovedRepairer;
export default withRouter(ApprovedRepairer);